import WebSocketStore from 'core/classes/services/WebSocketStore'

export enum ETranslationScope {
  apl = 'apl',
  bpRegistration = 'bpRegistration',
  aplAMS = 'aplAMS',

  partner360Hpscoutso = 'partner360Hpscoutso',
  bpReconfirmGuestLogin = 'bpReconfirmGuestLogin',
}

class TranslationAPI {
  public fetchTranslations = async (language: string, scope: string) => {
    const wsClient = WebSocketStore.get('onboarding')
    let result: Record<string, any> = {}

    try {
      const res = await wsClient.call({
        service: 'translation',
        action: 'fetch-guest',
        payload: { languages: [language], translationPairName: [scope] },
        withoutTokenRefresh: true,
      })

      if (res.status === 'success') {
        result = res.data
      }
    } catch (e) {
      // Nothing todo
    }

    return result
  }
}

export const translationAPI = new TranslationAPI()
